import Dummy from '../../utils/dummy';
import Main from '../../types/enums/main';
import seriesRequest from './seriesRequest';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

function seriesObservable(id: string) {
  return new Observable((subscriber) => {
    subscriber.next(Dummy.getPhoto());
    seriesRequest(id).then((data) => {
      setTimeout(() => {
        subscriber.next({ data, type: Main.RAILS });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}
export default seriesObservable;
